import React, { useState } from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import Swal from 'sweetalert2';
import api from '../../../api';

const StatusToggle = ({ id, status, onUpdate }) => {
  const [checked, setChecked] = useState(status === 'active');
  const [loading, setLoading] = useState(false);

  const handleChange = async (event) => {
    const newStatus = event.target.checked ? 'active' : 'inactive';
    setChecked(event.target.checked);
    setLoading(true);

    try {
         // ✅ use api instead of axios
       const res = await api.patch(`/vouchers/${id}/status`, {   // ✅ token auto added
      status: newStatus
     });
      // Call parent callback to update local state
      onUpdate(id, newStatus);
      setLoading(false);
      Swal.fire({
        icon: 'success',
        title: 'Status updated',
        text: `Voucher is now ${newStatus}`,
        timer: 1200,
        showConfirmButton: false
      });
    } catch (err) {
      console.error('Failed to update status', err);
      setChecked(!event.target.checked); // revert toggle
      setLoading(false);
      Swal.fire('Error', 'Could not update voucher status', 'error');
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={handleChange}
          disabled={loading}
          color="primary"
        />
      }
      label={checked ? 'Active' : 'Inactive'}
    />
  );
};

export default StatusToggle;
